import VueI18n from 'vue-i18n'
import installComponents from '@app/js/components'
import VueBem from '@aspectus/vue-bem'
import VueSocialSharing from 'vue-social-sharing'
import VueClipboard from 'vue-clipboard2'
import VModal from 'vue-js-modal'

export function install(Vue) {
  Vue.use(VueI18n)
  Vue.use(installComponents)
  Vue.use(VueBem, {
    blockNameKey: 'block',
  })
  Vue.use(VueSocialSharing)
  Vue.use(VueClipboard)
  Vue.use(VModal, {
    dynamicDefaults: {
      height: 'auto',
    },
  })
}

export default { install }
